import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useContactAttributesQuery } from "../api/contactAttributeService";
import { useDataFieldsQuery } from "../api/dataFieldService";
import { ContactAttributeOption } from "../types";

export const useContactAttributeOptions = () => {
	const { t } = useTranslation();
	const { contactAttributes, isLoading: isContactAttributesLoading } = useContactAttributesQuery();
	const { data: dataFields, isLoading: dataFieldIsLoading } = useDataFieldsQuery();

	const isLoading = isContactAttributesLoading || dataFieldIsLoading;

	const contactAttributeOptions = useMemo(() => {
		if (isLoading) return [];

		return contactAttributes
			.flatMap((attribute): ContactAttributeOption[] => {
				switch (attribute.type) {
					case "dataField": {
						const foundDataField = dataFields.find(({ id }) => attribute.entityType === id);
						if (!foundDataField) return [];
						return [
							{
								id: attribute.id,
								name: foundDataField.label,
								attribute,
								dataField: foundDataField,
							},
						];
					}
					case "relation": {
						if (attribute.entityType === "applications") {
							return [
								{
									id: attribute.id,
									name: t("Applications"),
									attribute,
									dataField: null,
								},
							];
						}
						return [
							{
								id: attribute.id,
								name: t(attribute.entityType),
								attribute,
								dataField: null,
							},
						];
					}
					default:
						return [
							{
								id: attribute.id,
								name: t(attribute.entityType),
								attribute,
								dataField: null,
							},
						];
				}
			})
			.sort((a, b) => a.name.localeCompare(b.name));
	}, [contactAttributes, dataFields, isLoading, t]);

	return {
		isLoading: isLoading,
		contactAttributeOptions,
	};
};
